export const pageAccessConstants = {
    //user page access
    GET_USER_PAGE_ACCESS_REQUEST: 'USER_GET_PAGE_ACCESS_REQUEST',
    GET_USER_PAGE_ACCESS_SUCCESS: 'USER_GET_PAGE_ACCESS_SUCCESS',
    GET_USER_PAGE_ACCESS_FAILURE: 'USER_GET_PAGE_ACCESS_FAILURE',

    // remove from access
    REMOVE_ACCESS: "CONFIGURATIONS_REMOVE_ACCESS"
}